import type { GuideLinkShape } from '../types';

export type GuideLinkWording = {
  /** Visible text for text shapes; the accessible name for the section control. */
  label: string;
  tooltip?: string;
};

/** "Learn more" never appears alone: every shape names its subject. */
export function guideLinkWording(
  shape: GuideLinkShape,
  {
    subject,
    featureName,
    articleTitle,
  }: {
    subject: string;
    featureName?: string;
    /**
     * Secondary action only: the resolved article is not a hub (a task or
     * troubleshooting article, or the fallback), so the link reads its title.
     */
    articleTitle?: string;
  },
): GuideLinkWording {
  switch (shape) {
    case 'section-control':
      return { label: `Learn about ${subject}`, tooltip: `About ${subject}` };
    case 'secondary-action':
      if (articleTitle) return { label: articleTitle };
      return { label: featureName ? `How ${featureName} works` : `Learn more about ${subject}` };
    case 'page-sentence':
      return { label: `Learn more about ${subject}` };
  }
}
